import React, {useCallback, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useDatelessSeoSRP} from 'hooks/useDatelessSeoSRP'
import {usePriceFilter} from 'hooks/usePriceFilter'
import {
  getShowTotalPrices,
  getShowTotalPriceToggle
} from 'modules/sapiSearch/selectors'
import {setShowTotalPrices} from 'modules/search/slice'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {TotalPriceToggleDesktop} from './Desktop/TotalPriceToggleDesktop'
import {TotalPriceToggleMobile} from './Mobile/TotalPriceToggleMobile'

export const TotalPriceToggle = () => {
  const {isMobile} = useDeviceLayout()
  const isDatelessSeoSRP = useDatelessSeoSRP()

  const dispatch = useDispatch()
  const showTotalPrices = useSelector(getShowTotalPrices)
  const showTotalPriceToggle = useSelector(getShowTotalPriceToggle)
  const {hasMultipleRooms} = usePriceFilter()

  const shouldShowTotalPriceToggle = showTotalPriceToggle && !isDatelessSeoSRP

  const handleChange = useCallback(() => {
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.PriceToggle,
        action: Action.Clicked
      })
    )
    dispatch(setShowTotalPrices(!showTotalPrices))
  }, [dispatch, showTotalPrices])

  useEffect(() => {
    if (!shouldShowTotalPriceToggle) return

    dispatch(
      trackEvent({
        category: Category.System,
        entity: Entity.PriceToggle,
        action: Action.Displayed
      })
    )
  }, [dispatch, shouldShowTotalPriceToggle])

  if (!shouldShowTotalPriceToggle) {
    return null
  }

  const totalPriceMessage = hasMultipleRooms ? (
    <FormattedMessageWrapper
      id="totalPriceToggle.multipleRoomsWithTaxAndFees"
      defaultMessage="Include all nights, rooms, taxes and fees in the price"
    />
  ) : (
    <FormattedMessageWrapper
      id="totalPriceToggle.withTaxAndFees"
      defaultMessage="Include all nights, taxes and fees in the price"
    />
  )

  if (isMobile) {
    return (
      <TotalPriceToggleMobile
        checked={showTotalPrices}
        onChange={handleChange}
        totalPriceMessage={totalPriceMessage}
      />
    )
  }

  return (
    <TotalPriceToggleDesktop
      checked={showTotalPrices}
      onChange={handleChange}
      totalPriceMessage={totalPriceMessage}
    />
  )
}
